var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMicIcon = function SvgMicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.821,
    height: 21.869
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MicIcon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M16 1.5a2.777 2.777 0 00-2.5 2.988v7.968a2.777 2.777 0 002.5 2.988 2.777 2.777 0 002.5-2.988V4.488A2.777 2.777 0 0016 1.5z",
    transform: "translate(-8.257 -1)",
    fill: "url(#MicIcon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 179",
    d: "M6.857.5C4.851.5 3.225 1.838 3.225 3.488v7.968c0 1.65 1.626 2.988 3.632 2.988s3.632-1.338 3.632-2.988V3.488C10.488 1.838 8.862.5 6.857.5z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M13.321 9.464v1.832a6.41 6.41 0 11-12.821 0V9.464",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 181",
    d: "M6.898 17.706v3.663",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 182",
    d: "M3.699 21.369h7.326",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMicIcon;